import React from 'react';

import Cards from './cards';
import { TESTIMONIALS_COACH } from '../constants/constants';

const TestimonialsPage = () => (
  <div className="testimonials__container">
    <h2 className="testimonials__title">Testimonials</h2>
    <div className="testimonials">
      {TESTIMONIALS_COACH.map(coachs => (
        <Cards
          description={coachs.description}
          nameCoach={coachs.nameCoach}
          descriptionCoach={coachs.descriptionCoach}
          imageCoach={coachs.imageCoach}
        />
      ))}
    </div>
  </div>
);

export default TestimonialsPage;
